import { Autocomplete, Box, FormControl, InputBase, TextField } from "@mui/material"
import { IApiFunc, IApiResult } from "auth/interface/api.interface"
import { useApi } from "auth/useApi3"
import { apiEndpoints } from "generated/apiEndpoints"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

type SearchProps = {
  setRegnr: any
  regnr: any
}

const SearchBar = ({ setRegnr, regnr }: SearchProps) => {
  const { t } = useTranslation()

  const [vehicleResult, vehicleApi] = useApi() as [IApiResult, IApiFunc]

  useEffect(() => {
    vehicleApi.get(apiEndpoints.assembly.listdevices)
  }, [])

  return (
    <Box>
      <Box
        component="form"
        sx={{
          p: "2px 4px",
          display: "flex",
          alignItems: "center",

          border: "1px solid #eee",
          borderRadius: "4px"
        }}
        noValidate
        autoComplete="off">
        {(() => {
          const options = Array.isArray(vehicleResult.data)
            ? vehicleResult.data.map((item: any) => ({
                label: `${item.deviceId} | ${item.internalDeviceId || ""}` || "",
                value: item.deviceId || ""
              }))
            : []

          return (
            <FormControl fullWidth>
              <Autocomplete
                loading={vehicleResult.status !== 2}
                loadingText={`${t("global.loading", "Loading")}...`}
                sx={{ width: "100%", background: (theme) => theme.palette.background.paper }}
                id="vehicle-autocomplete"
                options={options}
                getOptionLabel={(option) => option?.label || ""}
                onChange={(_, option) => {
                  setRegnr(option?.value || "")
                }}
                isOptionEqualToValue={(option, valueOption) => option.value === valueOption.value}
                includeInputInList
                value={options.find((i) => i.value?.toString() === regnr?.toString()) || null}
                renderInput={(params) => (
                  <InputBase
                    {...params.InputProps}
                    inputProps={params.inputProps}
                    placeholder={t("global.search", "Search")}
                    sx={{ width: "100%" }}
                  />
                )}
              />
            </FormControl>
          )
        })()}
      </Box>
    </Box>
  )
}

export default SearchBar
